import { ExclamationCircleOutlined, SaveOutlined } from "@ant-design/icons";
import { Table, Input, Modal, Row } from "antd";
import React, { useState } from "react";
import { elaborateWPdata, formatNumber, showError, showSuccess, unformatNumber } from "../../../../../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CostEstimation from "../../../../../services/api/CostEstimation";
import { setLoading } from "../../../../../redux/ducks/Loading";
import { concat, get, isEmpty } from "lodash";
import {
  initializeForm,
  resetForm,
  setDirty,
  setExpandedKeys,
  setValue,
} from "../../../../../redux/ducks/EditableTable";
import KickOff from "../../../../../services/api/KickOff";
import { setRefreshCostEstimation, setRefreshKickOff } from "../../../../../redux/ducks/ProjectEstimate";
import Button from "../../../../../components/functional_components/Button/PFButton";

const { confirm } = Modal;

const WPTable = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const getCustomForm = useSelector((state) => get(state.EditableTableDuck, "customForm", {}));
  const isDirtyCustomForm = useSelector((state) => get(state.EditableTableDuck, "isDirty", {}));
  const expandedRowKeysWP = useSelector((state) => get(state.EditableTableDuck, "expandedKeys", []));
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const [state, setState] = useState({
    wpContentExpanded: [],
    wbsId: "",
  });
  const columns = [
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.activityResource"),
      dataIndex: "activity",
      width: 200,
      fixed: "left",
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
      dataIndex: ["amountValues", "columnValueMap", "AP"],
      width: 100,
      fixed: "left",
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
      dataIndex: ["amountValues", "columnValueMap", "JANUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
      dataIndex: ["amountValues", "columnValueMap", "FEBRUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
      dataIndex: ["amountValues", "columnValueMap", "MARCH"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
      dataIndex: ["amountValues", "columnValueMap", "APRIL"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
      dataIndex: ["amountValues", "columnValueMap", "MAY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
      dataIndex: ["amountValues", "columnValueMap", "JUNE"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
      dataIndex: ["amountValues", "columnValueMap", "JULY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
      dataIndex: ["amountValues", "columnValueMap", "AUGUST"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
      dataIndex: ["amountValues", "columnValueMap", "SEPTEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
      dataIndex: ["amountValues", "columnValueMap", "OCTOBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
      dataIndex: ["amountValues", "columnValueMap", "NOVEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
      dataIndex: ["amountValues", "columnValueMap", "DECEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
      dataIndex: ["amountValues", "columnValueMap", "AS"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
      dataIndex: ["amountValues", "columnValueMap", "TOT"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];

  const getDisplayTipe = (propsType, isOnlyVisual) => {
    if (
      (propsType === "kick-off" && userInfo.canEditKickOff && !isOnlyVisual) ||
      (propsType !== "kick-off" && userInfo.canEditCostEstimation && !isOnlyVisual)
    ) {
      return "input";
    } else {
      return "text";
    }
  };

  const expandedRowRender = () => {
    const getValueForm = (amount, record, month) => {
      let valueForm = amount;
      getCustomForm[record.key] &&
        getCustomForm[record.key].forEach((a) => {
          if (a.month === month) {
            if (record.isHour) {
              valueForm = props.type === "kick-off" ? a.quantityKickOff : a.quantityEstimate;
            } else {
              valueForm = props.type === "kick-off" ? a.amountKickOff : a.amountEstimate;
            }
          }
        });
      return valueForm;
    };
    const columns = [
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.activityResource"),
        dataIndex: "activity",
        width: 200 + 8, // +8 to compensate the negative margin used by antd for expanded rows
        fixed: "left",
        render: (activity) => {
          let returnActivity = activity;
          if (activity === "work") returnActivity = t("projectEstimate.detail.tabs.costEstimation.table.work");
          else if (activity === "costs") returnActivity = t("projectEstimate.detail.tabs.costEstimation.table.costs");
          return returnActivity;
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
        dataIndex: "AP",
        width: 100,
        fixed: "left",
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
        dataIndex: "JANUARY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "JANUARY",
            value: getValueForm(amount, record, 1),
            lang: currentLanguage,
            id: "JANUARY",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 1),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
        dataIndex: "FEBRUARY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "FEBRUARY",
            value: getValueForm(amount, record, 2),
            lang: currentLanguage,
            id: "FEBRUARY",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 2),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
        dataIndex: "MARCH",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "MARCH",
            value: getValueForm(amount, record, 3),
            lang: currentLanguage,
            id: "MARCH",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 3),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
        dataIndex: "APRIL",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "APRIL",
            value: getValueForm(amount, record, 4),
            lang: currentLanguage,
            id: "APRIL",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 4),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
        dataIndex: "MAY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "MAY",
            value: getValueForm(amount, record, 5),
            lang: currentLanguage,
            id: "MAY",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 5),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
        dataIndex: "JUNE",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "JUNE",
            value: getValueForm(amount, record, 6),
            lang: currentLanguage,
            id: "JUNE",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 6),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
        dataIndex: "JULY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "JULY",
            value: getValueForm(amount, record, 7),
            lang: currentLanguage,
            id: "JULY",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 7),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
        dataIndex: "AUGUST",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "AUGUST",
            value: getValueForm(amount, record, 8),
            lang: currentLanguage,
            id: "AUGUST",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 8),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
        dataIndex: "SEPTEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "SEPTEMBER",
            value: getValueForm(amount, record, 9),
            lang: currentLanguage,
            id: "SEPTEMBER",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 9),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
        dataIndex: "OCTOBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "OCTOBER",
            value: getValueForm(amount, record, 10),
            lang: currentLanguage,
            id: "OCTOBER",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 10),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
        dataIndex: "NOVEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "NOVEMBER",
            value: getValueForm(amount, record, 11),
            lang: currentLanguage,
            id: "NOVEMBER",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 11),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
        dataIndex: "DECEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) => {
          const displayType = getDisplayTipe(props.type, record.isOnlyVisual);
          return formatNumber({
            name: "DECEMBER",
            value: getValueForm(amount, record, 12),
            lang: currentLanguage,
            id: "DECEMBER",
            displayType,
            decimalScale: displayType === "input" ? 2 : 0,
            suffix: record.isHour ? "HOUR" : "EUR",
            customInput: Input,
            onChange: (e) => handleChange(e, record.isHour ? "quantity" : "amount", record.key, 12),
          });
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
        dataIndex: "AS",
        fixed: "right",
        width: 100,
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
        dataIndex: "TOT",
        fixed: "right",
        width: 100,
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
    ];

    const handleChange = (e, type, row, column) => {
      dispatch(setDirty(true));
      getCustomForm[row].forEach((f, i) => {
        if (f.month === column) {
          dispatch(setValue(unformatNumber(e.target.value, currentLanguage, type), type, row, i, props.type));
        }
      });
    };

    return (
      <>
        <Row>
          <Table
            bordered
            dataSource={state.wpContentExpanded}
            columns={columns}
            size="small"
            pagination={false}
            scroll={{ x: 1500 }}
            className="fitExpandedRowInTableWidth"
          />
        </Row>
        <Row align="middle" className="mt-10 mr-10">
          <span className="PFred">
            {isDirtyCustomForm ? t("projectEstimate.detail.tabs.costEstimation.alertForm") : ""}
          </span>
        </Row>
        <Row align="middle" justify="end" className="mt-10">
          {props.status !== "RELEASED" && (
            <Button
              isDisabled={!(userInfo.canEditCostEstimation && isDirtyCustomForm)}
              currentIcon={<SaveOutlined className="icon-medium" />}
              clickCallback={handleSave()}
            />
          )}
        </Row>
      </>
    );
  };

  const getExpandedRowDataWp = (expanded, record) => {
    const expandFunction = async () => {
      let wbsId = "";
      dispatch(setLoading(true));
      dispatch(resetForm("custom"));
      const expandedKeys = [];
      let contentExpanded = [];
      if (expanded) {
        wbsId = record.wbsId;
        let wbs = {};
        if (props.type === "cost-estimation") {
          wbs = await CostEstimation.projectEstimateWorkPackageTableWPWbs(
            props.projectId,
            props.WpId,
            record.wbsId,
            filters.obj.year
          );
        } else if (props.type === "kick-off") {
          wbs = await KickOff.projectEstimateKickOffTableWPWbs(
            props.projectId,
            props.WpId,
            record.wbsId,
            filters.obj.year
          );
        }
        if (!isEmpty(wbs) && !wbs.error) {
          const dataElaborate = elaborateWPdata(wbs, userInfo, props.type);
          contentExpanded = dataElaborate.contentExpanded;
          expandedKeys.push(record.key);
          dispatch(initializeForm(record.wbsId, dataElaborate.customForm));
          dispatch(setExpandedKeys(expandedKeys));
        } else {
          showError(get(wbs, "error.messageCode", "ER000"));
        }
      }
      setState((prevState) => ({
        ...prevState,
        wpContentExpanded: contentExpanded,
        wbsId,
      }));
      dispatch(setLoading(false));
    };
    if (isDirtyCustomForm) {
      // If I write data on editable field and not yet saved, I show an alert
      confirm({
        title: t("projectEstimate.detail.tabs.costEstimation.confirmChangeRow"),
        icon: <ExclamationCircleOutlined />,
        onOk: async () => {
          expandFunction();
        },
        onCancel() {},
      });
    } else {
      expandFunction();
    }
  };

  const handleSave = () => async () => {
    dispatch(setLoading(true));
    let saveData = [];
    Object.keys(getCustomForm).forEach((f) => {
      saveData = concat(saveData, getCustomForm[f]);
    });
    let contentExpanded = [];
    if (props.type === "cost-estimation") {
      const responseCE = await CostEstimation.saveProjectEstimateWp(
        props.projectId,
        props.WpId,
        filters.obj.year,
        saveData
      );
      if (!responseCE.error) {
        dispatch(setRefreshCostEstimation(true));
        showSuccess();
        const costEstimationWbs = await CostEstimation.projectEstimateWorkPackageTableWPWbs(
          props.projectId,
          props.WpId,
          state.wbsId,
          filters.obj.year
        );
        if (!isEmpty(costEstimationWbs) && !costEstimationWbs.error) {
          const dataElaborate = elaborateWPdata(costEstimationWbs, userInfo, props.type);
          contentExpanded = dataElaborate.contentExpanded;
          dispatch(initializeForm(state.wbsId, dataElaborate.customForm));
        } else {
          showError(get(costEstimationWbs, "error.messageCode", "ER000"));
        }
      } else {
        showError(get(responseCE, "error.messageCode", "ER000"));
      }
    } else if (props.type === "kick-off") {
      const responseKO = await KickOff.saveKickOffWp(props.projectId, props.WpId, filters.obj.year, saveData);
      if (!responseKO.error) {
        dispatch(setRefreshKickOff(true));
        showSuccess();
        const kickOffWbs = await KickOff.projectEstimateKickOffTableWPWbs(
          props.projectId,
          props.WpId,
          state.wbsId,
          filters.obj.year
        );
        if (!isEmpty(kickOffWbs) && !kickOffWbs.error) {
          const dataElaborate = elaborateWPdata(kickOffWbs, userInfo, props.type);
          contentExpanded = dataElaborate.contentExpanded;
          dispatch(initializeForm(state.wbsId, dataElaborate.customForm));
        } else {
          showError(get(kickOffWbs, "error.messageCode", "ER000"));
        }
      } else {
        showError(get(responseKO, "error.messageCode", "ER000"));
      }
    }
    setState((prevState) => ({
      ...prevState,
      wpContentExpanded: contentExpanded,
    }));
    dispatch(setLoading(false));
  };

  return (
    <Table
      bordered
      dataSource={props.dataContentWP}
      columns={columns}
      size="small"
      pagination={false}
      scroll={{ x: 1500 }}
      expandable={{
        expandedRowRender,
        expandedRowKeys: expandedRowKeysWP,
        onExpand: (expanded, record) => getExpandedRowDataWp(expanded, record),
      }}
      rowClassName="table-secondary"
    />
  );
};

export default WPTable;
